import { createAction } from 'redux-actions';

export const onChangeQuery = createAction('PORTAL_USERS_CHANGE_QUERY');

export const onClearQuery = createAction('PORTAL_USERS_ON_CLEAR_QUERY');
